module.exports = __webpack_public_path__ + "static/media/2025.70381976.svg";